import { render, staticRenderFns } from "./NewAssetTypeBtn.vue?vue&type=template&id=e55ad5a8&scoped=true&"
import script from "./NewAssetTypeBtn.vue?vue&type=script&lang=js&"
export * from "./NewAssetTypeBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55ad5a8",
  null
  
)

export default component.exports